import * as React from 'react';
export const IcOrder = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.7 5.75l-7-2.62a2 2 0 00-1.4 0l-7 2.62a1.71 1.71 0 00-.23.13L12 8.93l7.93-3a1.708 1.708 0 00-.23-.18zM3 7.62v8.76a2 2 0 001.3 1.87l6.7 2.51V10.69L3 7.61v.01zm18 0l-8 3.08v10.06l6.7-2.51a2 2 0 001.3-1.87V7.62z'
      fill='currentColor'
    />
  </svg>
);
